<template>
  <payment-container v-model="_selected" v-bind="containerProps">
    <o-chip variant="success" size="lg" flat>
      {{ $currency.format(option.data.balanceLabel) }}
    </o-chip>
  </payment-container>
</template>

<script setup lang="ts">
import PaymentContainer from '@/components/order/elements/payments/PaymentContainer.vue'

const { $api, $i18n } = useNuxtApp()

interface Props {
  order: any
  amount: string | number
  tip?: number | string | null
  option: any
  selected?: string | null
}

const props = withDefaults(defineProps<Props>(), {
  tip: null,
  selected: null,
})

const emit = defineEmits<{
  (e: 'update:selected', value: string): void
}>()

const _selected = computed({
  get: () => props.selected,
  set: (value: string) => emit('update:selected', value),
})

const active = computed(() => props.option.guid === props.selected)

const containerProps = computed(() => ({
  label: $i18n.t('order.customerCredit'),
  info: $i18n.t('general.customer'),
  option: props.option,
}))

async function process() {
  const { amount, tip, option } = props
  const payment = option.create(amount, tip)
  const response = await $api.order.addPayment(String(props.order.idOrder), payment)
  return response.data
}

async function saturate() {
  const response = await $api.order.get(String(props.order.idOrder))
  return response.data
}

defineExpose({ process })
</script>
